module.exports = __webpack_public_path__ + "img/Accounting.6a5cf18a.svg";